import { render, staticRenderFns } from "./MyZs2.vue?vue&type=template&id=9fe486ca&scoped=true&"
import script from "./MyZs2.vue?vue&type=script&lang=js&"
export * from "./MyZs2.vue?vue&type=script&lang=js&"
import style0 from "./MyZs2.vue?vue&type=style&index=0&id=9fe486ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe486ca",
  null
  
)

export default component.exports